<ng-container *ngIf="viewed">
  <ng-container
    *ngIf="loading && project == null && subProject == null; else viewDetail"
  >
    <mat-spinner color="primary" diameter="48"></mat-spinner>
  </ng-container>
  <ng-template #viewDetail>
    <div class="container edit-project overflow-hidden pl-0 ml-0">
      <mat-horizontal-stepper
        #projectStepper
        *ngIf="project.id == null || !client"
        class="adjust-stepper-icons"
        [selectedIndex]="2"
      >
        <ng-template matStepperIcon="edit" let-index="index">
          {{ index + 1 }}
        </ng-template>

        <ng-template matStepperIcon="done" let-index="index">
          {{ index + 1 }}
        </ng-template>

        <mat-step>
          <ng-template matStepLabel>Configuratie</ng-template>
          <div>
            <client-product-wrapper
              *ngFor="let product of project.products; let index = index"
              [inputProject]="project"
              [inputProduct]="product"
              (productInitialized)="productInitialized($event, index)"
              (save)="save.next()"
            >
            </client-product-wrapper>
          </div>

          <mat-card
            *ngIf="project.id == null && showAddProduct"
            class="mat-elevation-z0 clickable overflow-hidden vertically-center"
            (click)="addProduct()"
          >
            <mat-icon
              class="plus-sign vertically-center"
              svgIcon="add"
            ></mat-icon>
            <span class="vertically-center">Onderdeel toevoegen</span>
          </mat-card>
        </mat-step>

        <mat-step>
          <ng-template matStepLabel>Ontwerp</ng-template>

          <app-design-step-content
            [project]="project"
            [client]="client"
            (save)="save.next()"
          ></app-design-step-content>
        </mat-step>

        <mat-step>
          <ng-template matStepLabel>Plaatsing</ng-template>

          <app-placement-step-content
            [project]="project"
            [subProject]="subProject"
            (save)="save.next()"
          ></app-placement-step-content>
        </mat-step>

        <mat-step>
          <ng-template matStepLabel>Overzicht</ng-template>
          <client-adjustment-header
            [title]="'Te plaatsen'"
            [type]="subProject.expectedType.toLowerCase()"
            [currentCreatedAt]="currentCreatedAt"
            [projectContacts]="project.projectContacts"
            [extraCompanyContacts]="project.projectExtraCompanyContacts"
            [client]="true"
          ></client-adjustment-header>

          <ng-container *ngIf="project.products?.length > 0">
            <project-detail-card
              [cardType]="'configuration'"
              [products]="project.products"
              [firstProduct]="project.products[0]"
              [project]="project"
              [client]="true"
            ></project-detail-card>

            <project-detail-card
              [cardType]="'design'"
              [products]="project.products"
              [assets]="designPictures"
              [ipBoardExamples]="ipBoardExamples"
              [project]="project"
            ></project-detail-card>

            <project-detail-card
              [cardType]="'placement'"
              [firstProduct]="project.products[0]"
              [projectPlacement]="subProject.projectPlacement"
              [baseProject]="subProject"
              [project]="project"
              [assets]="placementAssets"
            ></project-detail-card>

            <project-detail-card
              [cardType]="'execution'"
              [products]="project.products"
              [baseProject]="subProject"
              [project]="project"
              [assets]="executionAssets"
              [client]="true"
              [componentsExecuted]="componentsExecuted"
            ></project-detail-card>
          </ng-container>

          <ng-container *ngIf="selectedCompany != null">
            <project-detail-card
              *ngIf="!fromOldSystem && selectedCompany != null"
              [cardType]="'facturation'"
              [project]="project"
              [baseProject]="subProject"
              [company]="selectedCompany"
              [client]="true"
            ></project-detail-card>
          </ng-container>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </ng-template>
</ng-container>
